





























































import { Component, Vue } from 'vue-property-decorator';
import {performLogin} from "../../endpoints";
import DateFormat from "date-fns/format";

@Component
export default class Login extends Vue {

    emailInputModel: string = "";
    passwordInputModel: string = "";
    validated: boolean = false;
    error: string | null = null;
    submitted: boolean = false;

    async onSubmitButtonClick(event) {

        event.preventDefault();

        if(!this.validated) {
            return;
        }

        this.submitted = true;
        this.error = null;

        const payload = {
            email: this.emailInputModel,
            password: this.passwordInputModel
        };

        try {
            const result = await performLogin(JSON.stringify(payload));

            this.$store.commit('setUser', result);

            this.$router.push("/");
        } catch (e) {
            this.error = e.error;
            this.submitted = false;
        }

    }

    onInputChange() {
        this.validated = this.passwordInputModel.length > 0 && this.emailInputModel.length > 0;
    }
}
